export default __webpack_public_path__ + "static/media/kwid-medium1.19657627.jpg";